(function () {
  'use strict';

  var body = document.body;
  if (!body || !body.classList.contains('slimeatory-shop')) return;

  /* Accent color: keep whatever color the page already uses for its header
     (each collection / product sets its own). Liquid already set it when the
     product has a slime_identifier_color. */
  function parseRgb(value) {
    var match = value && value.match(/rgba?\(([^)]+)\)/);
    if (!match) return null;
    var parts = match[1].split(',').map(function (part) { return parseFloat(part); });
    if (parts.length > 3 && parts[3] === 0) return null;
    return parts;
  }

  function isUsableAccent(rgb) {
    if (!rgb) return false;
    var max = Math.max(rgb[0], rgb[1], rgb[2]);
    var min = Math.min(rgb[0], rgb[1], rgb[2]);
    // Skip white, black and greys; they would make the accent invisible.
    return max - min > 24;
  }

  if (!body.style.getPropertyValue('--shop-accent-override')) {
    var header = document.querySelector('.header-content');
    var headerColor = header ? window.getComputedStyle(header).backgroundColor : '';
    var rgb = parseRgb(headerColor);
    if (isUsableAccent(rgb)) {
      body.style.setProperty('--shop-accent-override', headerColor);
    }
  }

  /* Limited collection: each card is followed by an offset circle carrying the
     product's color. Put that color on the card instead. */
  function moveCardColors(root) {
    var circles = (root || document).querySelectorAll('#MainContent .circle_backdrop');
    var moved = 0;
    Array.prototype.forEach.call(circles, function (circle) {
      var card = circle.previousElementSibling;
      if (!card || !card.classList.contains('product-block')) return;
      var color = circle.style.backgroundColor;
      if (color) {
        card.style.setProperty('--card-accent', color);
        card.classList.add('shop-card--accent');
        moved += 1;
      }
    });
    if (moved > 0 && moved === circles.length) {
      body.classList.add('shop-cards-ready');
    }
  }

  moveCardColors(document);

  /* Entrance motion */
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reducedMotion.matches || !('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, {
    rootMargin: '0px 0px -6% 0px',
    threshold: 0.06
  });

  function register(element, delay) {
    if (element.hasAttribute('data-shop-reveal')) return;
    element.setAttribute('data-shop-reveal', 'true');
    element.classList.add('shop-reveal');
    element.style.setProperty('--shop-reveal-delay', delay + 'ms');
    observer.observe(element);
  }

  function registerAll(root) {
    var scope = root || document;

    // Product cards stagger across each row.
    var cards = scope.querySelectorAll('#MainContent .grid-flex > .product-block, #MainContent .product-block.grid-flex__item');
    Array.prototype.forEach.call(cards, function (card, index) {
      register(card, (index % 4) * 70);
    });

    // Other content blocks reveal as a whole.
    var blocks = scope.querySelectorAll(
      '#MainContent .gallery__item, #MainContent .image-with-text, #MainContent .rich-text-section, ' +
      '#MainContent .collapsible-tabs, #MainContent .full-width-image .page-width, #MainContent .collection-block'
    );
    Array.prototype.forEach.call(blocks, function (block, index) {
      register(block, (index % 3) * 60);
    });
  }

  body.classList.add('shop-motion-ready');
  registerAll(document);

  // Filtering, sorting and paging replace the product grid without a reload.
  if ('MutationObserver' in window) {
    var main = document.getElementById('MainContent');
    if (main) {
      new MutationObserver(function (mutations) {
        var changed = mutations.some(function (mutation) { return mutation.addedNodes.length > 0; });
        if (!changed) return;
        moveCardColors(main);
        registerAll(main);
      }).observe(main, { childList: true, subtree: true });
    }
  }

  document.addEventListener('shopify:section:load', function (event) {
    moveCardColors(event.target);
    registerAll(event.target);
  });
}());
